/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-delivery-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-delivery-api-client";
import type { FragmentsDeliveryAPIClientGetDeliveryStatusQueryResponse, FragmentsDeliveryAPIClientGetDeliveryStatusPathParams, FragmentsDeliveryAPIClientGetDeliveryStatus404 } from "../models/FragmentsDeliveryAPIClientGetDeliveryStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { fragmentsDeliveryAPIClientGetDeliveryStatus } from "../axios/fragmentsDeliveryAPIClientGetDeliveryStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const fragmentsDeliveryAPIClientGetDeliveryStatusQueryKey = (fragmentId: FragmentsDeliveryAPIClientGetDeliveryStatusPathParams["fragmentId"]) => ["fragments-delivery-api", { url: '/delivery/:fragmentId', params: {fragmentId:fragmentId} }] as const

export type FragmentsDeliveryAPIClientGetDeliveryStatusQueryKey = ReturnType<typeof fragmentsDeliveryAPIClientGetDeliveryStatusQueryKey>

export function fragmentsDeliveryAPIClientGetDeliveryStatusQueryOptions(fragmentId: FragmentsDeliveryAPIClientGetDeliveryStatusPathParams["fragmentId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = fragmentsDeliveryAPIClientGetDeliveryStatusQueryKey(fragmentId)
  return queryOptions<FragmentsDeliveryAPIClientGetDeliveryStatusQueryResponse, ResponseErrorConfig<FragmentsDeliveryAPIClientGetDeliveryStatus404>, FragmentsDeliveryAPIClientGetDeliveryStatusQueryResponse, typeof queryKey>({
   enabled: !!(fragmentId),
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return fragmentsDeliveryAPIClientGetDeliveryStatus(fragmentId, config)
   },
  })
}

/**
 * @description Retrieves the current delivery status and progress for a fragment
 * @summary Get delivery status for a fragment
 * {@link /delivery/:fragmentId}
 */
export function useFragmentsDeliveryAPIClientGetDeliveryStatus<TData = FragmentsDeliveryAPIClientGetDeliveryStatusQueryResponse, TQueryData = FragmentsDeliveryAPIClientGetDeliveryStatusQueryResponse, TQueryKey extends QueryKey = FragmentsDeliveryAPIClientGetDeliveryStatusQueryKey>(fragmentId: FragmentsDeliveryAPIClientGetDeliveryStatusPathParams["fragmentId"], options: 
{
  query?: Partial<QueryObserverOptions<FragmentsDeliveryAPIClientGetDeliveryStatusQueryResponse, ResponseErrorConfig<FragmentsDeliveryAPIClientGetDeliveryStatus404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? fragmentsDeliveryAPIClientGetDeliveryStatusQueryKey(fragmentId)

  const query = useQuery({
   ...fragmentsDeliveryAPIClientGetDeliveryStatusQueryOptions(fragmentId, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<FragmentsDeliveryAPIClientGetDeliveryStatus404>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}